<script setup>
import Advantages from "./components/advantages/advantages-info.vue";
import Hero from "./components/hero/feedback-hero.vue";
import Offers from "./components/offers/offers-info.vue";
import ProductInfo from "./components/product-info/product-info.vue";
import Footer from "./components/footer/feedback-footer.vue";

import Form from "./components/form/feedback-form.vue";
import { ref } from "vue";
import { useI18n } from "vue-i18n";

const {locale} = useI18n({useScope: "global"});
const lang = ref(localStorage.getItem("lang") || "ru")

const handleChange = (event) => {
    localStorage.setItem("lang", event.target.value);
    locale.value = event.target.value;
}
</script>

<template>
    <img class="logo" src="../../assets/images/logo-extended.svg"/>
    <select
      v-model="lang"
      class="dropbtn custom-select"
      @change="handleChange($event)"
    >
        <option
          class="custom-select-opt"
          value="kz"
        >
          KZ
        </option>
        <option
          class="custom-select-opt"
          value="en"
        >
          EN
        </option>
        <option
          class="custom-select-opt"
          value="ru"
        >
            RU
        </option>
    </select>

    <Hero/>

    <Form 
        uniq-id="mobile"
        scroll-id="mobile-form"
        class="mobile-form"
    />

    <div class="content">
        <ProductInfo/>
        <Offers/>
        <Advantages/>
    </div>

    <Footer/>
</template>

<style scoped>
.logo {
    position: absolute;
    top: 15px;
    left: calc(50% - 86px)
}

.custom-select {
    width: auto;
    border: none;
    background: url("../../assets/images/arrow-menu.png");
    background-repeat: no-repeat;
    background-position: right;
    padding-left: 0.75rem;
    padding-bottom: 6px;
    padding-right: 13px;

    position: absolute;
    top: 15px;
    right: 15px;
}

.content {
    display: grid;

    width: 100%;
    max-width: 1280px;
    margin: 85px auto 0;
}

.mobile-form {
    display: none;
}

@media screen and (max-width: 1280px) {
    .logo {
        left: 40px;
        top: 20px;
    }

    .mobile-form {
        display: grid;
    }

    .content {
        margin: 70px auto 0;
    }
}
</style>